import { axiosInstance } from '../../App';
import { ColumnDTO, ExportConfigDTO, exportFile, FilterDTO, GetItemsProps } from "medere-ui-framework";
import { SectorDTO } from '../../dto/SectorDTO';

export function getLotsInformation(offset:number, pageSize:number, params:any) {
    return axiosInstance.get(`/api/secured/stock/stockrestcontroller/loadLotInformation`, {
        params: {
            offSet: offset,
            pageSize:pageSize,
            stockItemDescription: params.stockItemDescription,
            lotName: params.lotName,
            dateFrom:params.dateFrom,
            dateTo:params.dateTo,
        }
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
        throw error;
    });
}
export function getProducts ({filterValue,offSet,pageSize}:GetItemsProps){
    return axiosInstance.get(`/api/secured/stock/stockrestcontroller/loadStockItems`, {
        params: {
            offSet: offSet,
            pageSize:pageSize,
            stockItemDescription: filterValue
        }
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
        throw error;
    });
}

export function getAllSectors({offSet, pageSize, filterValue}: GetItemsProps) {
    return axiosInstance.post(`/api/secured/stock/stockrestcontroller/getAllSectors`, {
        params: {
            offSet: offSet,
            pageSize: pageSize,
            sortingFieldInfoList: [],
            filters: [],
        }
    }).then(response => {
        // filterValue es el texto a filtrar si no es vacio
        // en response.data es un array y tiene cada indice un objeto que tiene un atributo name, filtrar con filterValue
        const newArray = response.data.filter((item: any) => !filterValue || item.name.toLowerCase().includes(filterValue.toLowerCase()));
        return newArray;
    });
}

export function getValorizedExistences(offset: number, pageSize: number, params: any) {
    return axiosInstance.get(`/api/secured/stock/stockrestcontroller/getValorizedExistences`, {
        params: {
            healthPatientServiceId: params.healthPatientServiceId,
            initialDateTime: params.initialDateTime,
            finalDateTime: params.finalDateTime,
            serviceEnded: params.serviceEnded,
            sector: params.sector?.sector ?? -1,
            offset,
            pageSize
        }
    }).then(res => {
        if (res.data && Array.isArray(res.data.data)) return res.data.data;
    });
}

export function exportValorizedExistencesReport(params: {
    filterDTO: FilterDTO,
    multiSortMeta: any,
    healthPatientServiceId: number,
    initialDateTime: Date,
    finalDateTime: Date,
    serviceEnded: boolean | null,
    sector?: { sector: number } 
}, columns: ColumnDTO[]) {
    const exportConfigDTO: ExportConfigDTO = {
        loadConfigDTO: {
            offset: 0,
            pageSize: 0,
            sortingFieldInfoList: params.multiSortMeta,
            filters: params.filterDTO 
        },
        columns
    };
    return exportFile(
        '/api/secured/stock/stockrestcontroller/exportValorizedExistencesReport',
        exportConfigDTO,
        {
            healthPatientServiceId: params.healthPatientServiceId,
            initialDateTime: params.initialDateTime,
            finalDateTime: params.finalDateTime,
            serviceEnded: params.serviceEnded,
            sector: params.sector?.sector ?? -1
        }
    );
}

export function useStockService() {
  return {
    getLotsInformation,
    getProducts,
    getAllSectors,
    getValorizedExistences,
    exportValorizedExistencesReport,
  }
}
